export const SITE = {
  name: "Babylon Deli",
  tagline: "Fresh & Authentic.",
  address: "17 Mount Druitt Rd, Mount Druitt NSW 2770",
  addressQuery: "17+Mount+Druitt+Rd+Mount+Druitt+NSW+2770",
  phone: "+61 424 260 070",
  phoneHref: "tel:+61424260070",
  contact: "Ray · Director",
  email: "Babylondeli1@gmail.com",
  emailHref: "mailto:Babylondeli1@gmail.com",
  instagram: "https://instagram.com/babylon.deli",
  instagramHandle: "@babylon.deli",
  facebook: "https://www.facebook.com/babylondeli",
  facebookHandle: "Babylon Deli",
  tiktok: "https://www.tiktok.com/@babylon.deli",
  tiktokHandle: "@babylon.deli",
  // Paste the widget iframe URL here (e.g. https://snapwidget.com/embed/XXXXXX) to switch the
  // home page feed from the photo grid to the auto-updating Instagram widget.
  instagramWidgetUrl: "",
};

export const HOURS = [
  { day: "Monday", weekday: 1, open: 8, close: 18, deliClose: 17 },
  { day: "Tuesday", weekday: 2, open: 8, close: 18, deliClose: 17 },
  { day: "Wednesday", weekday: 3, open: 8, close: 18, deliClose: 17 },
  { day: "Thursday", weekday: 4, open: 8, close: 20, deliClose: 19 },
  { day: "Friday", weekday: 5, open: 8, close: 18, deliClose: 17 },
  { day: "Saturday", weekday: 6, open: 9, close: 17, deliClose: 16 },
  { day: "Sunday", weekday: 0, open: 9, close: 17, deliClose: 16 },
];

export const formatHour = (h) => {
  const period = h >= 12 ? "PM" : "AM";
  const hour = h % 12 === 0 ? 12 : h % 12;
  return `${hour}:00 ${period}`;
};

export const isOpenNow = () => {
  const now = new Date();
  const hour = now.getHours() + now.getMinutes() / 60;
  const today = HOURS.find((d) => d.weekday === now.getDay());
  return Boolean(today) && hour >= today.open && hour < today.close;
};

export const BREADS = [
  { name: "Focaccia Bread", price: "17" },
  { name: "Turkish Bread", price: "16" },
  { name: "Ciabatta Roll", price: "16" },
];

export const CATEGORIES = ["All Sandwiches", "Regular Menu", "Halal Menu"];

export const MENU = [
  {
    id: "the-babylon-special",
    name: "The Babylon Special",
    category: "Regular Menu",
    chip: "House Favorite",
    description:
      "Our signature — prosciutto and creamy burrata with basil pesto mayo, cherry tomato, balsamic glaze and rocket.",
    tags: ["House Favorite"],
    ingredients: ["Prosciutto", "Burrata", "Basil pesto mayo", "Cherry tomato", "Balsamic glaze", "Rocket"],
    image: "/sandwiches/the-babylon-special.jpg",
    alt: "The Babylon Special — prosciutto, burrata, cherry tomato and rocket on Turkish bread",
  },
  {
    id: "the-hercules",
    name: "The Hercules",
    category: "Regular Menu",
    chip: "Regular Menu",
    description:
      "A triple-meat heavyweight — mortadella, salami and prosciutto with stracciatella, pesto, cherry tomato and antipasto.",
    tags: ["Triple Meat"],
    ingredients: ["Mortadella", "Salami", "Prosciutto", "Stracciatella", "Pesto", "Cherry tomato", "Antipasto"],
    image: "/sandwiches/the-hercules.jpg",
    alt: "The Hercules — mortadella, salami and prosciutto with stracciatella",
  },
  {
    id: "the-domenica",
    name: "The Domenica",
    category: "Regular Menu",
    chip: "Regular Menu",
    description: "Mild salami and prosciutto with bocconcini, mix leaf, pesto mayo and sun-dried tomato.",
    tags: [],
    ingredients: ["Mild salami", "Prosciutto", "Bocconcini", "Mix leaf", "Pesto mayo", "Sun-dried tomato"],
    image: "/sandwiches/the-domenica.jpg",
    alt: "The Domenica — mild salami, prosciutto and bocconcini",
  },
  {
    id: "kala-orexi",
    name: "Kala-Orexi",
    category: "Regular Menu",
    chip: "Regular Menu",
    description:
      "Ham and olive-studded mortadella with provolone, grilled eggplant, roasted capsicum, cherry tomato and herb mayo.",
    tags: [],
    ingredients: ["Ham", "Mortadella with olives", "Provolone", "Grilled eggplant", "Roasted peppers & capsicum", "Cherry tomato", "Herb mayo"],
    image: "/sandwiches/kala-orexi.jpg",
    alt: "Kala-Orexi — ham, mortadella with olives, grilled eggplant and roasted capsicum",
  },
  {
    id: "the-piccante",
    name: "The Piccante",
    category: "Regular Menu",
    chip: "Spicy",
    description:
      "Hot Spanish and Hungarian salami fired up with chilli mayo, jalapeño, stracciatella and sun-dried tomato.",
    tags: ["Spicy"],
    ingredients: ["Hot Spanish salami", "Hungarian salami hot", "Chilli mayo", "Jalapeño", "Stracciatella", "Sun-dried tomato"],
    image: "/sandwiches/the-piccante.jpg",
    alt: "The Piccante — hot salami, jalapeño and stracciatella",
  },
  {
    id: "the-boston",
    name: "The Boston",
    category: "Regular Menu",
    chip: "Regular Menu",
    description: "Sliced turkey with cranberry sauce, provolone, mix leaf and fresh tomato.",
    tags: [],
    ingredients: ["Turkey", "Cranberry sauce", "Mix leaf", "Provolone", "Fresh tomato"],
    image: "/sandwiches/the-boston.jpg",
    alt: "The Boston — turkey, cranberry sauce and provolone",
  },
  {
    id: "the-garden",
    name: "The Garden",
    category: "Regular Menu",
    chip: "Vegetarian",
    description: "Our vegetarian build — mix leaf, pesto, grilled eggplant, antipasto and roasted capsicum.",
    tags: ["Vegetarian"],
    ingredients: ["Mix leaf", "Pesto", "Grilled eggplant", "Antipasto", "Roasted capsicum"],
    image: "/sandwiches/the-garden.jpg",
    alt: "The Garden — vegetarian, grilled eggplant and roasted capsicum",
  },
  {
    id: "the-babylon-halal",
    name: "The Babylon",
    category: "Halal Menu",
    chip: "Halal",
    description: "Wagyu beef with basil pesto mayo, cherry tomato, burrata, balsamic glaze and rocket.",
    tags: ["Halal", "Wagyu"],
    ingredients: ["Wagyu beef", "Basil pesto mayo", "Cherry tomato", "Burrata", "Balsamic glaze", "Rocket"],
    image: "/sandwiches/the-babylon-halal.jpg",
    alt: "The Babylon (Halal) — wagyu beef, burrata and rocket",
  },
  {
    id: "the-piccante-halal",
    name: "The Piccante",
    category: "Halal Menu",
    chip: "Halal · Spicy",
    description: "Halal salami and pastrami with chilli mayo, jalapeño, stracciatella and sun-dried tomato.",
    tags: ["Halal", "Spicy"],
    ingredients: ["Halal salami", "Pastrami", "Chilli mayo", "Jalapeño", "Stracciatella", "Sun-dried tomato"],
    image: "/sandwiches/the-piccante-halal.jpg",
    alt: "The Piccante (Halal) — halal salami and pastrami with jalapeño",
  },
  {
    id: "the-domenica-halal",
    name: "The Domenica",
    category: "Halal Menu",
    chip: "Halal",
    description: "Halal mortadella and silverside with bocconcini, mix leaf, pesto mayo and sun-dried tomato.",
    tags: ["Halal"],
    ingredients: ["Halal mortadella", "Silverside", "Bocconcini", "Mix leaf", "Pesto mayo", "Sun-dried tomato"],
    image: "/sandwiches/the-domenica-halal.jpg",
    alt: "The Domenica (Halal) — halal mortadella and silverside with bocconcini",
  },
  {
    id: "the-boston-halal",
    name: "The Boston",
    category: "Halal Menu",
    chip: "Halal",
    description: "Smoked turkey with cranberry sauce, mix leaf, provolone and fresh tomato.",
    tags: ["Halal"],
    ingredients: ["Smoked turkey", "Cranberry sauce", "Mix leaf", "Provolone", "Fresh tomato"],
    image: "/sandwiches/the-boston-halal.jpg",
    alt: "The Boston (Halal) — smoked turkey and cranberry sauce",
  },
];

export const AMBIANCE = {
  counter: "/shop/signage.jpg",
  prep: "/shop/counter.jpg",
  shelf: "/shop/olives.jpg",
};
